import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal, Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

const Acciones = ({handleCloseCierre}) => {
  const data_cierre_modal = useSelector((state) => state.cierreGestionReducer)
  const {cfg_form19} = data_cierre_modal
  
  const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
  const {montosInformados} = data_modal_cia
 
  const [desabilitaBtnCierre, setDesabilitaBtnCierre]=useState(true)  
 
  useEffect(()=>{
    if(montosInformados  && montosInformados.montosInformados[0]['MontoCosto'] > 0) {
      setDesabilitaBtnCierre(false);
    }

},[montosInformados])

  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>

     <Container>
          <Row>
              <Col className='d-flex align-items-end justify-content-end m-2'>
                  <Button className='m-2 w-auto' variant='outline-info' onClick={handleCloseCierre}>
                      {cfg_form19 && cfg_form19.cfg_form19["cierregestion-btn-cerrar"]} 
                  </Button>
                  <Button className='m-2' disabled={desabilitaBtnCierre} variant='actualizar' type='onSubmit'                    
                      name='buscar'>
                      {cfg_form19 && cfg_form19.cfg_form19["cierregestion-btn-aplicar"]}
                  </Button>
              </Col>
          </Row>
      </Container>
    </>
  )
}

export default Acciones
